export enum EmployeeRequestResponsibleForAnswerStatusEnum {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  NOT_APPLICABLE = 'not_applicable',
}

export const EmployeeRequestResponsibleForAnswerRequestableStatuses: EmployeeRequestResponsibleForAnswerStatusEnum[] = [
  EmployeeRequestResponsibleForAnswerStatusEnum.PENDING,
  EmployeeRequestResponsibleForAnswerStatusEnum.ACCEPTED,
  EmployeeRequestResponsibleForAnswerStatusEnum.REJECTED,
];

export const EmployeeRequestResponsibleForAnswerStatusLabels: Record<EmployeeRequestResponsibleForAnswerStatusEnum, string> = {
  [EmployeeRequestResponsibleForAnswerStatusEnum.PENDING]: 'Pendiente',
  [EmployeeRequestResponsibleForAnswerStatusEnum.ACCEPTED]: 'Aceptada',
  [EmployeeRequestResponsibleForAnswerStatusEnum.REJECTED]: 'Rechazada',
  [EmployeeRequestResponsibleForAnswerStatusEnum.NOT_APPLICABLE]: 'No aplicable',
};
